
import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Login from './Components/Login';
import Dashboard from './Components/Dashboard';
import WorkStation from './Components/WorkStation'; 
import Navbar from './Components/Navbar';
import Empolyees from './Components/Empolyees';
import ReportPage from './Components/ReportPage';
import WorkGroup from './Components/WorkGroup';
import Products from './Components/Products';
import Wg_Dashboard from './Components/Wg_Dashboard'

function App() {
  return (
    <BrowserRouter>
      <AppWithRouter />
    </BrowserRouter>
  );
}

function AppWithRouter() {
  const [navVisible, showNavbar] = useState(false);
  const location = useLocation();

  const renderPage = (Component) => (
    <div className={!navVisible ? "page" : "page page-with-navbar"}>
      <Component />
    </div>
  );

  return (
    <div className="App">
      {/* Conditional Navbar visibility */}
      {(location.pathname !== '/' && location.pathname !== '/wg_dashboard') && (
        <Navbar visible={navVisible} show={showNavbar} />
      )}

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/wg_dashboard" element={ <Wg_Dashboard/> } />
        <Route path="/dashboard" element={renderPage(Dashboard)} />
        <Route path="/workstation" element={renderPage(WorkStation)} />
        <Route path="/workgroup" element={renderPage(WorkGroup)} />
        <Route path="/employees" element={renderPage(Empolyees)} />
        <Route path="/report" element={renderPage(ReportPage)} />
        <Route path="/product" element={renderPage(Products)} />
      </Routes>
    </div>
  );
}

export default App;

